import { render } from "./upload-limit-exceptions-dialog.vue?vue&type=template&id=1072f974&ts=true"
import script from "./upload-limit-exceptions-dialog.ts?vue&type=script&lang=ts"
export * from "./upload-limit-exceptions-dialog.ts?vue&type=script&lang=ts"

import "./upload-limit-exceptions-dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__